import { alpha } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../theme';

const useStyles = (isModal, isRotatedIOS) =>
  makeStyles(() =>
    createStyles({
      wrapper: {
        position: 'relative',
        width: '100%',
        height: '100%',
      },
      bumper: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        background: colorsPalette.blackPure,
        display: 'none',
      },
      active: {
        display: 'block',
      },
      video: {
        width: '100%',
        height: '100%',
      },
      fullScreenIcon: {
        position: 'absolute',
        top: 10,
        left: 10,
        color: alpha(colorsPalette.white, 0.7),
        zIndex: 1300,
        ...(!isRotatedIOS && { display: 'none' }),
        '&:hover': {
          color: colorsPalette.white,
        },
      },
      fullScreen: {
        borderRadius: 0,
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1200,
      },
    }),
  );

export default useStyles;
